import { useEffect, useState } from 'react';
import Modal from '../../../../../../component/modal/Modal';
import Button from '../../../../../../component/ui/Button';
import { getPlanUsages } from '../../../../../../services/settings/subscriptions';
import { usageOverviewStatusColor, usageOverviewStatusText } from '../../../../../../utils/utility';
import { Check, X } from 'lucide-react';
import { PageSmallLoader } from '../../../../../../component/PageLoader';

export default function UsageOverviewModal({
  isOpenModal,
  setIsOpenModal,
  planType,
  setIsOpenUpgradeModal
}) {

  const [overallUsages, setOverallUsages] = useState({})
  const [isLoading, setLoading] = useState(false)

  const headers = [
    { label: 'FEATURE', width: '30%', className: 'text-dark fs-5 font-medium' },
    { label: 'USAGE', width: '25%', className: 'text-dark fs-5 font-medium' },
    { label: 'PROGRESS', width: '25%', className: 'text-center text-dark fs-5 font-medium' },
    { label: 'STATUS', width: '20%', className: 'text-end fs-5 font-medium' }
  ];

  async function fetchPlanUsages() {
    try {
      setLoading(true)
      const data = await getPlanUsages()
      setOverallUsages(data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPlanUsages();
  }, [])

  return (
    <Modal
      className="usage-overview-model"
      title={"Usage Overview"}
      badge={planType || 'Free Plan'}
      subtitle={'Showing usage for your current billing period'}
      isOpen={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      cancelButton={() => {
        setIsOpenModal(false);
      }}
      bodyClassName="d-flex flex-column overflow-hidden"
    >
      {isLoading && <div className='d-flex justify-content-center align-items-center py-4'><PageSmallLoader /></div>}
      {!isLoading && overallUsages && <div className='overflow-auto'><div className="overflow-auto rounded-4 border" style={{ maxHeight: '300px' }}>
        <table className="currency-table">
          <thead className="bg-light">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  style={{ width: header.width }}
                  className={header.className || ''}
                >
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {overallUsages && Object.entries(overallUsages).map(([key, item]) => {
              const isBoolean = item.type === 'boolean';
              const isUnlimited = item.total === 'unlimited' || item.total_allowed === 'unlimited';

              // Format usage label
              let usageText = '';
              let isIncluded = false;
              if (isBoolean) {
                isIncluded = item.total === true || item.total === 1 || item.total_allowed === true || item.total_allowed === 1;
                usageText = isIncluded ? 'Included' : 'Not Included';
              } else if (isUnlimited) {
                usageText = `${item.total_consumed} / Unlimited`;
              } else {
                usageText = `${item.total_consumed} / ${item.total}`;
              }

              // Determine status and style
              let statusText = '';
              let badgeColorClass = '';
              let progressColorClass = '';

              if (isBoolean) {
                statusText = isIncluded ? 'Included' : 'Not Included';
                badgeColorClass = isIncluded ? 'bg-primary-subtle text-primary badge-primary' : 'bg-secondary-subtle text-secondary badge-secondary';
              } else {
                statusText = usageOverviewStatusText(item.usage_percentage);
                const colorObj = usageOverviewStatusColor(item.usage_percentage);
                badgeColorClass = `${colorObj.bg} ${colorObj.text} ${colorObj.badge}`;

                // Solid color for progress bar
                if (item.usage_percentage >= 100) {
                  progressColorClass = 'bg-danger';
                } else if (item.usage_percentage >= 80) {
                  progressColorClass = 'bg-warning';
                } else {
                  progressColorClass = 'bg-success';
                }
              }

              return (
                <tr key={key} style={{ transition: 'background-color 0.2s' }}>
                  <td className='fs-5 fw-light'>{item.name}</td>
                  <td className="fs-5 fw-semibold">
                    {isBoolean ? (
                      <span className={`d-flex align-items-center gap-2 ${isIncluded ? 'text-primary' : 'text-secondary'}`}>
                        {isIncluded ? <Check size={16} strokeWidth={3} /> : <X size={16} strokeWidth={3} />}
                        {usageText}
                      </span>
                    ) : (
                      usageText
                    )}
                  </td>

                  <td>
                    {!isBoolean && !isUnlimited ? (
                      <div
                        className="progress"
                        style={{
                          height: "8px",
                          borderRadius: "10px",
                          backgroundColor: "#f0f2f5"
                        }}
                      >
                        <div
                          className={`progress-bar ${progressColorClass}`}
                          style={{
                            width: `${item.usage_percentage}%`,
                            borderRadius: "10px",
                            transition: "width 0.3s ease-in-out"
                          }}
                        />
                      </div>
                    ) : (
                      <span className="text-muted fs-5 d-flex justify-content-center">—</span>
                    )}
                  </td>

                  <td className="text-end">
                    <span
                      className={`fs-5 badge rounded-pill px-3 py-2 font-medium ${badgeColorClass}`}
                    >
                      {statusText}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
        <div className="d-flex justify-content-end align-items-center gap-4 mt-4">
          <Button
            type="button"
            className="mt-0 border-primary btn-primary rounded-4 fs-5 fw-light add-pro py-3 px-5 "
            button="Upgrade Plan"
            onClick={() => {
              setIsOpenModal(false);
              setIsOpenUpgradeModal(true)
            }}
          />
          <Button
            type="button"
            className="mt-0 btn-gray rounded-4 text-dark fs-5 fw-light add-pro px-5"
            button="Cancel"
            onClick={() => setIsOpenModal(false)}
          />
        </div></div>}
    </Modal>
  );
}